import CertificateComponents from './CertificateComponents';

export default CertificateComponents;
